import { Children, ReactNode } from "react";

import { Stack, Typography } from "@mui/material";

type SectionPreviewProps = {
  title: string;
  children: ReactNode;
};

export default function SectionPreview({ title, children: content }: SectionPreviewProps) {
  const render = () => {
    return (
      <Stack spacing={1}>
        <Typography fontSize={18} fontWeight={600} variant="h6">
          {title}
        </Typography>
        <Typography component="div" textAlign="justify">
          {content}
        </Typography>
      </Stack>
    );
  };

  return Children.count(content) !== 0 ? render() : null;
}
